import { useContext, useEffect, useState } from 'react';

import AccountPickerContext from 'contexts/AccountPickerContext';
import STORE from 'store';

// Listens to the staff-managed reason codes for a bonus program. Returns an
// empty list until the snapshot resolves (and when none are configured, which
// is the signal the override picker uses to stay hidden).
const useBonusReasonCodes = (bonusProgramId: string) => {
  const { selectedAccountId } = useContext(AccountPickerContext);
  const [reasonCodes, setReasonCodes] = useState<BonusReasonCodes.ReasonCode[]>(
    [],
  );

  useEffect(() => {
    let isActive = true;
    const unsubscribe = STORE.bonus
      .getBonusReasonCodesRef({
        accountId: selectedAccountId,
        bonusProgramId,
      })
      .onSnapshot((snapshot) => {
        if (!isActive) {
          return;
        }
        const data: BonusReasonCodes.ReasonCode[] = [];
        snapshot.docs.forEach((doc) => data.push(doc.data()));
        setReasonCodes(data);
      });

    return () => {
      isActive = false;
      unsubscribe();
    };
  }, [bonusProgramId, selectedAccountId]);

  return reasonCodes;
};

export default useBonusReasonCodes;
